'use strict';

/**
 * @description Initialize event handlers on landing page
 */

window.addEventListener('mainJsLoaded', function () {
    turtleMusesInit();
});

function turtleMusesInit() {
    var $newInSlider = $('.tiles-container'),
        $catalogTilesContainer = $('.catalog-tiles-container'),
        $tiles = $('.catalog-category-tile');

    $('.category-tile-background.forced').on('load', function () {
        if ($catalogTilesContainer.length) {
            if (window.vbqUtils.breakpoint.is('tabletAndDesktop')) {
                calculateTileSize();

                $catalogTilesContainer = $catalogTilesContainer.masonry({
                    columnWidth: '.catalog-grid-sizer',
                    itemSelector: '.catalog-category-tile'
                });
                $catalogTilesContainer.addClass('masonry-initialized');
            }
            else {
                $catalogTilesContainer.filter('.masonry-initialized').masonry('destroy');
                $catalogTilesContainer.removeClass('masonry-initialized');
            }

            $catalogTilesContainer.addClass('visible');
        }
    });

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        if (window.vbqUtils.breakpoint.is('tabletAndDesktop')) {
            calculateTileSize();

            if ($catalogTilesContainer.length) {
                $catalogTilesContainer.masonry();
                $catalogTilesContainer.addClass('masonry-initialized');

                if (!$catalogTilesContainer.hasClass('visible')) {
                    $catalogTilesContainer.addClass('visible');
                }
            }
        }
        else {
            $catalogTilesContainer.filter('.masonry-initialized').masonry('destroy');
            $catalogTilesContainer.removeClass('masonry-initialized');
        }
    }, 200));

    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobileAndTablet'),
            enter: function () {
                // clean fromDesktop logic
                $newInSlider.slick('unslick');

                // set mobileAndTablet logic
                var $viewMoreLink = $('.home-newin-view-more'),
                    counter = 4,
                    end = 4,
                    items = $('.newin-tile-wrapper').length,
                    showTiles = function () {
                        if (end >= items) {
                            $viewMoreLink.hide();
                        }
                        $('.newin-tile-wrapper').each(function (index) {
                            if (index === end) {
                                return false;
                            }
                            $(this).show();
                        });
                    };

                if ($('.home-newin-productcarousel').length === 1) { // logic only works for 1 new-in block
                    showTiles();
                }
                else {
                    $viewMoreLink.hide();
                    $('.newin-tile-wrapper').show();
                }

                $viewMoreLink.on('click', function (e) {
                    end += counter;
                    showTiles();
                });
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktop'),
            enter: function () {
                // clean mobileAndTablet logic
                $('.home-newin-view-more').off('click');

                // set fromDesktop logic
                if ($newInSlider.children().length > 4) {
                    $newInSlider.slick({
                        slidesToShow: 4,
                        dots: false,
                        arrows: true
                    });
                }
            }
        }
    ]);
}

function calculateTileSize() {
    var $catalogTilesContainer = $('.catalog-tiles-container'),
        $tiles = $('.catalog-category-tile'),
        widthMultiplier,
        heightMultiplier,
        layoutSplit,
        currentUnit = $catalogTilesContainer.width() / 4,
        $value;

    $tiles.each(function (key, value) {
        $value = $(value);

        if ($value.attr('data-layout')) {
            layoutSplit = $value.attr('data-layout').split('x');
        }

        if (layoutSplit && layoutSplit.length == 2) {
            widthMultiplier = layoutSplit[0];
            heightMultiplier = layoutSplit[1];
            $value.width(Math.ceil(currentUnit * widthMultiplier));
            $value.height(Math.ceil(currentUnit * heightMultiplier));
        }
    });
}
